<template>

    <v-btn color="primary" @click="btnAdd_OnClick()" 
        :loading="loading" 
        :disabled="disabled"
        style="min-width:0;padding:0"
        text small  >
      <v-icon 
        dark

      >mdi-plus-circle</v-icon>
    </v-btn>
      
</template>


<script>


export default {
  props: {
    loading: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  computed:{
  },
  methods: {
    btnAdd_OnClick(){
      this.$emit('click');
    }
  }
}
</script>